/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'icon-close': {
    width: 8,
    height: 8,
    viewBox: '0 0 8 8',
    data: '<defs><path pid="0" d="M.777.088l.069.057L4 3.3 7.154.145l.069-.057a.496.496 0 0 1 .632.758L4.7 4l3.154 3.154a.496.496 0 0 1-.632.758l-.069-.057L4 4.7.846 7.855l-.069.057a.496.496 0 0 1-.632-.758L3.3 4 .145.846A.496.496 0 0 1 .777.088z" id="svgicon-icon-close-a"/></defs><g _fill="none" fill-rule="evenodd"><mask id="svgicon-icon-close-b" _fill="#fff"><use xlink:href="#svgicon-icon-close-a"/></mask><use _fill="#979797" fill-rule="nonzero" xlink:href="#svgicon-icon-close-a"/><path pid="1" _fill="#376F99" mask="url(#svgicon-icon-close-b)" d="M-1-1H9V9H-1z"/></g>'
  }
})
